import loadable from '@loadable/component';

export const GuitarworldSiteWrapper = loadable(
  () => import(/* webpackChunkName: "guitarworld-site" */ './GuitarworldSiteWrapper'),
);
